import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
	name: 'highlight',
})
export class HighlightPipe implements PipeTransform {
	constructor(private sanitizer: DomSanitizer) {}

	transform(
		originalHtml: string,
		textToFind: string,
		cssClass = 'highlighter'
	): SafeHtml {
		if (
	  typeof originalHtml !== 'string' ||
	  !textToFind ||
	  typeof textToFind !== 'string'
		) {
	  return originalHtml;
		}

		const cleaned = textToFind.trim();
		if (!cleaned) {return originalHtml;}

		const escapeRegex = (str: string) =>
	  str.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');

		const buildFlexiblePattern = (term: string): string => {
	  const chars = term.split('');
	  return chars
				.map((char) =>
		  /[a-zA-Z0-9]/.test(char)
						? escapeRegex(char)
						: `[\\s._-]*${escapeRegex(char)}[\\s._-]*`
				)
				.join('[\\s._-]*');
		};

		const terms = cleaned
	  .split(/\s+/)
	  .map((term) => buildFlexiblePattern(term));

		const regex = new RegExp(`(${terms.join('|')})`, 'gi');

		// Create a detached DOM and safely modify text nodes only
		const parser = new DOMParser();
		const doc = parser.parseFromString(`<div>${originalHtml}</div>`, 'text/html');
		const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);

		const textNodes: Text[] = [];

		let node;
		while ((node = walker.nextNode())) {
	  textNodes.push(node as Text);
		}

		for (const textNode of textNodes) {
	  if (!textNode.nodeValue) {continue;}
	  const replaced = textNode.nodeValue.replace(regex, (match) => {
				return `<span class="${cssClass}">${match}</span>`;
	  });

	  if (replaced !== textNode.nodeValue) {
				const spanContainer = doc.createElement('span');
				spanContainer.innerHTML = replaced;
				textNode.parentNode?.replaceChild(spanContainer, textNode);
	  }
		}

		return this.sanitizer.bypassSecurityTrustHtml(doc.body.innerHTML);
	}
}
